import { Button } from "./styles";

type Props = {
  title?: any;
  email?: any;
  blank: boolean;
};

const MailtoLink: React.FC<Props> = (props) => {
  const { email, title } = props;

  if (typeof email !== "string") return null;
  if (typeof title !== "string") return null;

  return <Button href={`mailto:${email}`}>{title}</Button>;
};

export default MailtoLink;
